'use strict';

(()=>{
	'use strict';

	// Lojas content
	if( $('section.lojas-products').length ) {
		$('a[data-show-content]').on('click', function(e) {
			e.preventDefault();

			const content = $(this).attr('data-show-content');
			openContentLojas(content);

			$('.product-list').removeClass('product-list-active');
			$(this).parent().addClass('product-list-active');
		});

		const openContentLojas = (content) => {
			$('.lojas-products-feat-active').removeClass('lojas-products-feat-active');
			$('.lojas-products article.' + content).addClass('lojas-products-feat-active').fadeIn();
		}
	}
})();
